import React from "react";
import Slideshow, { SlideshowProps } from "./Slideshow";
import useMediaQuery from "react-responsive/src/useMediaQuery";

const ResponsiveSlideshow: React.FC<
  React.PropsWithChildren<SlideshowProps>
> = ({ fullscreen = true, ...props }) => {
  const isTabletOrDesktop = useMediaQuery({
    query: "(min-width: 768px) AND (min-height: 600px)"
  });

  const responsiveProps = {
    ...props,
    fullscreen: fullscreen && isTabletOrDesktop
  };
  return <Slideshow {...responsiveProps} />;
};

export default ResponsiveSlideshow;
